import React, { Component } from 'react';
import GetSeleccionLogin from './getSeleccionLogin';
import GetRegistre from './getRegistre';
import GetLoginUser from './getLoginUser';


class getLoading extends Component {
  constructor(){
    super();
    this.state = {
        modulo_modal : '',
        msg_loading : false
    }
  }
  get_go_to =(modulo_modal)=>{
    this.setState({
      modulo_modal
    })
  }
  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }
  render() {
    const modulo_modal = this.state.modulo_modal
    let modulo_modal_dir
    if(modulo_modal===''){
      modulo_modal_dir=<React.Fragment>
                        <GetSeleccionLogin  separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}   uuid_imagen={this.props.uuid_imagen} get_go_to={this.get_go_to} token={this.props.token} dir_url={this.props.dir_url}/>
                      </React.Fragment>
    }
    if(modulo_modal==='registre_new'){
      modulo_modal_dir=<React.Fragment>
                        <GetRegistre database={this.props.database} telefono_contacto={this.props.telefono_contacto} setTokenClient={this.props.setTokenClient} codigo={this.props.codigo} get_loading={this.get_loading} get_go_to={this.get_go_to} token={this.props.token} dir_url={this.props.dir_url}/>
                      </React.Fragment>
    }
    if(modulo_modal==='login_session'){
      modulo_modal_dir=<React.Fragment>
                        <GetLoginUser setTokenClient={this.props.setTokenClient} get_loading={this.get_loading} get_go_to={this.get_go_to} token={this.props.token} dir_url={this.props.dir_url}/>
                      </React.Fragment>
    }
    let modal_loading
    const msg_loading = this.state.msg_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }
    return (
      <React.Fragment>
        {modal_loading}
        {modulo_modal_dir}
      </React.Fragment>
    );
  }

}
export default getLoading;
